import { find } from "lodash-es";

import { useGlobalStore } from "@/store";

import type { UserRoleType } from "../types/user.type";

/**
 * @param grantedRoles 有权限进行某个操作的角色们
 */
export function useCheckRoleExists(grantedRoles: UserRoleType[]) {
  const { roles } = useGlobalStore.getState();
  const hasPermission = find(roles, ({ role }) => grantedRoles.includes(role));
  return hasPermission;
}
